import React from 'react';
import PropTypes from 'prop-types';
import {motion, AnimatePresence} from 'framer-motion';

import {useField} from 'formik';

const ErrorMessage = ({name}) => {
  const [, meta] = useField(name);
  return (
    <AnimatePresence>
      {meta.touched && meta.error && (
        <motion.div
          layout
          initial={{height: 0, opacity: 0}}
          animate={{opacity: 1, height: 'auto'}}
          exit={{opacity: 0, height: 0}}
          transition={{duration: 0.3}}
          className="text-red-600 bg-red-200 border-red-600 rounded text-sm px-2 pt-1 mt-2">
          {meta.error}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

ErrorMessage.propTypes = {
  name: PropTypes.string.isRequired,
};

export default ErrorMessage;
